import { createCommunicationColumns } from "./communication-table-helper";
import {
  buildCommunicationLogisticsPreview,
  buildCommunicationOrderPreview,
  buildCommunicationQuestionPreview,
  formatCommunicationPreviewDate,
} from "./communication-preview-helper";
import {
  getCommunicationConfidenceTone,
  normalizeCommunicationConfidence,
} from "./communication-confidence-helper";
import { buildCommunicationTaskSteps } from "./communication-step-helper";
import { formatCommunicationStandNumberLabel } from "./communication-stand-format-helper";
import {
  getCommunicationSummary,
  getTaskStatusFromValues,
  useCommunicationStore,
} from "./communication-store";

const CommunicationHelpers = {
  createCommunicationColumns,
  buildCommunicationOrderPreview,
  buildCommunicationQuestionPreview,
  buildCommunicationLogisticsPreview,
  getCommunicationConfidenceTone,
  buildCommunicationTaskSteps,
  formatCommunicationStandNumberLabel,
  formatCommunicationPreviewDate,
  normalizeCommunicationConfidence,
  useCommunicationStore,
  getCommunicationSummary,
  getTaskStatusFromValues,
};

export default CommunicationHelpers;

export * from "./communication-types-helper";
export * from "./communication-confidence-helper";
export * from "./communication-step-helper";
export * from "./communication-stand-format-helper";
